var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distance flex-row items-center"},[(_vm.distance >= 0)?_c('span',{staticClass:"value flex-wrap",class:{ 'c-primary': _vm.distance <= 20 }},[_vm._v(" "+_vm._s(_vm.distance)+"km ")]):_vm._e(),_c('img',{staticClass:"flex-wrap",attrs:{"src":_vm.distance > 20 ? _vm.ugly : _vm.smile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }